var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "temperature_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".temperature_svg__st0,.temperature_svg__st1{fill:none;stroke:var(--color-text);stroke-width:3;stroke-miterlimit:10}.temperature_svg__st1{stroke-linecap:round;stroke-linejoin:round}.temperature_svg__st2{fill:var(--color-icon-secondary)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "temperature_svg__st0",
    d: "M49.8 137.5c-9.4 0-17-7.6-17-17v-93c0-9.4 7.6-17 17-17s17 7.6 17 17v93c0 9.4-7.6 17-17 17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "temperature_svg__st0",
    d: "M53.7 120.1c0-2.2-1.8-3.9-3.9-3.9-2.2 0-3.9 1.7-3.9 3.9s1.7 3.9 3.9 3.9 3.9-1.7 3.9-3.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "temperature_svg__st1",
    d: "M49.8 116.2v-92M66.8 106.9h-9.1M66.8 96.5h-5M57.7 86.2h9.1M66.8 75.8h-5M57.7 65.5h9.1M66.8 55.1h-5M57.7 44.8h9.1M66.8 34.4h-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "temperature_svg__st0",
    d: "M105.6 122.7c0-3.6-2.9-6.5-6.5-6.5s-6.5 2.9-6.5 6.5 2.9 6.5 6.5 6.5 6.5-2.8 6.5-6.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "temperature_svg__st2",
    d: "M101 122.7c0-1.1-.9-1.9-1.9-1.9-1.1 0-1.9.9-1.9 1.9 0 1.1.9 1.9 1.9 1.9 1 .1 1.9-.8 1.9-1.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "temperature_svg__st1",
    d: "M99.1 116.2v-92M106.1 102.9h9.1M106.1 94.5h4.9M115.2 86.2h-9.1M106.1 77.8h4.9M115.2 69.5h-9.1M106.1 61.1h4.9M115.2 52.8h-9.1M106.1 44.4h4.9M115.2 36.1h-9.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "temperature_svg__st2",
    d: "M43.8 34.7v42.7s-3 1.6-5 5V34.7c0-1.4 1.1-2.5 2.5-2.5s2.5 1.2 2.5 2.5z"
  })));
}
export default SvgTemperature;